import * as yup from 'yup';

import { ContactDetail } from './types';
import { axiosClient } from '../axiosClient';

type Params = {
  contactId: string;
};

export const getContactDetails = ({ contactId }: Params) => {
  if (yup.string().uuid().isValidSync(contactId)) {
    return axiosClient.get<ContactDetail[]>(`/customers/uid/${contactId}`);
  }

  return axiosClient.get<ContactDetail[]>(
    `/customers/${parseInt(contactId, 10)}`
  );
};
